import {type FormEvent, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../api/AuthContext';

export default function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e: FormEvent) => {
        e.preventDefault();
        try {
            await login(username, password);
            navigate('/afkastberegner');
        } catch (err) {
            console.error('Login failed', err);
            alert('Login failed: please check your credentials');
        }
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen">
            <form onSubmit={handleSubmit} className="w-full max-w-sm">
                <div className="card w-full bg-base-100 shadow-xl p-6">
                    <h2 className="text-xl mb-4">Login</h2>
                    <input
                        type="text"
                        placeholder="Username"
                        className="input input-bordered w-full mb-2"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        className="input input-bordered w-full mb-4"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <button type="submit" className="btn btn-primary w-full">
                        Login
                    </button>
                </div>
            </form>
        </div>
    );
}
